import { useRef, useState } from 'react';
import { useProducts } from '../lib/products-api';
import { PopoverPortal } from './PopoverPortal';

export function ProductPicker({
  value: _value,
  valueName,
  valueCode,
  onChange,
  disabled,
}: {
  value: string;
  valueName?: string | null;
  valueCode?: string | null;
  onChange: (id: string, code: string, name: string) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [search, setSearch] = useState('');
  const productsQ = useProducts({
    pageSize: 50,
    ...(search.trim() && { search: search.trim() }),
    status: 'ACTIVE',
  });
  // Se code e' solo la versione normalizzata del name (es. SWEET_BERRY vs
  // SWEET BERRY), mostrare il code e' ridondante. Marco 25/05.
  const codeIsRedundant =
    !!valueCode &&
    !!valueName &&
    valueCode.toUpperCase().replace(/[_\s-]+/g, '') ===
      valueName.toUpperCase().replace(/[_\s-]+/g, '');
  const display = valueName
    ? codeIsRedundant
      ? valueName
      : `${valueCode ? valueCode + ' — ' : ''}${valueName}`
    : '';
  return (
    <div className="relative">
      <button
        ref={anchorRef}
        type="button"
        className="w-full rounded-md border border-slate-300 px-2 py-1 text-left text-xs"
        onClick={() => !disabled && setOpen((v) => !v)}
        disabled={disabled}
      >
        {display || '— scegli prodotto —'}
      </button>
      <PopoverPortal anchorRef={anchorRef} open={open} onClose={() => setOpen(false)}>
        <div className="w-80 rounded-md border border-slate-300 bg-white p-2 shadow-lg">
          <input
            autoFocus
            type="text"
            className="mb-2 block w-full rounded border border-slate-300 px-2 py-1 text-xs"
            placeholder="Cerca prodotto..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <ul className="max-h-56 overflow-y-auto text-xs">
            {productsQ.isLoading && <li className="p-1 text-slate-400">Caricamento...</li>}
            {productsQ.data && productsQ.data.items.length === 0 && (
              <li className="p-1 text-slate-400">Nessun risultato</li>
            )}
            {productsQ.data?.items.map((p) => (
              <li
                key={p.id}
                className="cursor-pointer rounded p-1 hover:bg-slate-100"
                onClick={() => {
                  onChange(p.id, p.code, p.name);
                  setOpen(false);
                  setSearch('');
                }}
              >
                {p.driveLegendId !== null && (
                  <span className="inline-block min-w-[24px] mr-1 rounded bg-brand-50 px-1 text-center font-mono text-[10px] font-semibold text-brand-700">
                    {p.driveLegendId}
                  </span>
                )}
                <span className="font-mono text-slate-400">{p.code}</span>
                <span className="ml-2 font-medium">{p.name}</span>
                <span className="ml-2 text-slate-500">{p.category}</span>
              </li>
            ))}
          </ul>
        </div>
      </PopoverPortal>
    </div>
  );
}
